<template>
	<el-card class="box-card">
		<template #header>
			 <div class="header">
				<el-button type="primary" size="small" icon="el-icon-plus" @click="edit('')">新增</el-button>
				<el-button type="warning" size="small" icon="el-icon-plus" @click="updatePosterSort()">更新排序</el-button>
			</div>
		</template>
		<div class="col">
			<el-table empty-text="暂无数据" v-loading="loading" :data="list.filter(data => !search || data.series_name.toLowerCase().includes(search.toLowerCase()))"
			 style="width: 100%;" :default-sort="sort" border highlight-current-row :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
			 <el-table-column label="排序" prop="sort_order">
			 	<template v-slot="scope">
			 	    <el-input :style="{'width':'20%'}" type="text" v-model="scope.row.sort_order"></el-input>
			 	</template>
			 </el-table-column>
				<!-- <el-table-column prop="id" label="编号" sortable width="180">
				</el-table-column> -->
				<el-table-column label="系列类型名称">
					<template #default="scope">
						<span>{{scope.row.series_name}}</span>
					</template>
				</el-table-column>
				<el-table-column
				  label="开启状态"
				>
				  <template #default="scope">
						<el-switch
							v-model="scope.row.status"
							active-color="#409EFF"
							inactive-color="#F56C6C"
							:active-value="1"
							:inactive-value="2"
							@change="changeEnabled(scope.row.status, scope.row.id)">
						</el-switch>
				  </template>
				</el-table-column>
				<el-table-column align="right">
					<template #header>
						<el-input v-model="search" size="medium" placeholder="输入类型名称" />
					</template>
					<template #default="scope">
						<el-button type="primary" size="medium" @click="edit(scope.row)">编辑</el-button>
						<el-button type="danger" size="medium" @click="destroy(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</el-card>
	<el-dialog :title="title" v-model="dialogFormVisible">
		<el-form :model="item" ref="form" :rules="rules">
			<el-form-item label="系列名" prop="series_name">
				<el-input style="width: 200px;" v-model="item.series_name" size="small" placeholder="系列名"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
			<el-button size="mini" type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default{
		name:'RakutenHomeSeriesCloth',
		data(){
			return {
				title: '新增',
				dialogFormVisible: false,
				loading:true,
				list:[],
				sort_orders_string:[],
				search: '',
				sort: {
					prop: 'id',
					order: 'descending'
				},
				item:{
					series_name:'',
					sort_order:0,
				},
				rules:{
						series_name: [{
						required: true,
						message: '请填写系列名',
						trigger: 'blur'
					}],
				}
			}
		},
		methods: {
			edit(row) {
				this.dialogFormVisible = true;
				let temp = this.cloneObj(row);
				// console.log(temp)
				if (row) {
					this.title = '编辑';
					this.item = temp;
				} else {
					this.resetObj(this.item)
				}
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			changeEnabled(status, id){
				let select_id = id;
				let change_status = status;
				if(select_id){
					this.loading=true;
					this.httpPost({
						url:'/admin/rakuten/rakutenSeriesClothStatus',
						data:{id:select_id,status:change_status}
					}).then((res)=>{
						if(res.code ==1){
							this.$message.success(res.msg);
							this.loading =false;
						}
					})
				}
			},
			updatePosterSort(){
				let ids = [];
				this.sort_orders_string =[];
				this.$confirm('此操作将更新排序, 是否继续?', '提示', {
				                        confirmButtonText: '确定',
				                        cancelButtonText: '取消',
				                        type: 'warning'
				                    }).then((re) => {
				                        for (let i in this.list){
				                            if (this.sort_orders_string.indexOf(this.list[i].sort_order) == '-1'){
				                                //==-1表示该字符串不在此数组,返回值为-1
				                                this.sort_orders_string.push(this.list[i].sort_order);
				                                ids.push({id:this.list[i].id,sort_order:this.list[i].sort_order});
				                            }else{
				                                this.$message.error('排序有重复值');
				                                this.sort_orders_string = [];
				                                return;
				                            }
				                        }
										// console.log(ids);return;
										this.httpPost({
											url:'/admin/rakuten/rakutenSeriesClothSort',
											data:ids
										}).then((res)=>{
											if(res.code ==1){
												this.$message.success(res.msg);
												this.rakutenSeriesClothList();
											}
										})
				                    })
			},
			submit() {
				// console.log(this.item);
				// return false;
				this.$refs['form'].validate((valid) => {
					if (valid) {
			
						this.httpPost({
							url: '/admin/rakuten/rakutenSeriesClothUpdate',
							data: this.item
						}).then((re) => {
			
							// console.log(re);
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.rakutenSeriesClothList();

						})
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			
			},
			destroy(index, row) {
				console.log(index, row)
				let id = row.id
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/rakuten/rakutenSeriesClothDelete', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.rakutenSeriesClothList()
				})
			},
			rakutenSeriesClothList(){
					this.httpPost({
					url: '/admin/rakuten/rakutenSeriesClothList',
					data: {
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.list = temp;
					this.loading = false;
				
				}).catch((err) => {
					this.loading = false;
				})
			},
		},
		created(){
			this.rakutenSeriesClothList();
		}
	}
</script>

<style>
</style>
